import { iFacadeConfig } from '@andbank-myinvestor/arq/lib/onboarding';

import { getCurrentLanguage } from '../common/utils/utils';

const config: iFacadeConfig['i18nConfig'] = {
	availableLanguages: {
		es: {
			default: 'es',
		},
		ca: {
			default: 'ca',
		},
		pt: {
			default: 'pt',
		},
		default: {
			default: 'ca',
		},
	},
	initialLanguage: getCurrentLanguage(),
};

const languagesInUse = [
	{
		label: 'onboarding:idioma:cat',
		value: 'ca',
	},
	{
		label: 'onboarding:idioma:cas',
		value: 'es',
	},
	{
		label: 'onboarding:idioma:pt',
		value: 'pt',
	},
];

// PT is routable (so /pt/inicio works) but hidden from the language selector.
const SELECTOR_HIDDEN_LANGUAGES = new Set(['pt']);

const getAvailableLanguages = (t: any) => {
	return languagesInUse
		.filter(lang => !SELECTOR_HIDDEN_LANGUAGES.has(lang.value))
		.map(lang => ({
			label: t(lang.label),
			value: lang.value,
		}));
};

export { config, languagesInUse, getAvailableLanguages };
